module.exports = __webpack_public_path__ + "static/img/zbbl1-2.b150727.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/zbbl1-2.png
// module id = 811
// module chunks = 0